import React, { Component } from "react";
import styled from "styled-components";
import Grid from "@tleef/react-grid";
import * as luxon from "luxon";

import Layout from "../components/Layout";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Content from "../components/Content";

import estudios from "../content/data/estudios-biblicos";
import { rhythm } from "../utils/typography";
import { graphql } from "gatsby";
import Footer from "../components/Footer";
import SideBar from "../components/SideBar";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 120px;
`;

const StudyContainer = styled.div`
  padding-bottom: ${rhythm(1)};
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: ${rhythm(2)};
`;

const Title = styled.div`
  color: #000;
  font-size: 20px;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  line-height: 1.1;
`;

const DateTime = styled.div`
  color: #929292;
`;

const Verses = styled.div`
  color: #016597;
`;

const Description = styled.p`
  margin-top: ${rhythm(0.25)};
  margin-bottom: ${rhythm(0.25)};
  color: #000;
  font-size: 14px;
`;

const Download = styled.a`
  color: #016597;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default class EstudiosBiblicosPage extends Component {
  constructor() {
    super();

    this.renderStudy = this.renderStudy.bind(this);
  }

  render() {
    return (
      <Layout>
        <Seo title="Estudios Bíblicos" keywords={[`iglesia`]} />
        <Container>
          <Header />
          <Content>
            <Inner>
              <Grid container spacing={40}>
                <Grid item xs={12} md={8}>
                  {estudios
                    .sort((a, b) => {
                      return a.date > b.date ? -1 : b.date > a.date ? 1 : 0;
                    })
                    .map(this.renderStudy)}
                </Grid>
                <Grid item xs={12} md={4}>
                  <SideBar fixTop={180} fixBottom={140} />
                </Grid>
              </Grid>
            </Inner>
          </Content>
          <Footer />
        </Container>
      </Layout>
    );
  }

  renderStudy({ title, date, versos, description, url }) {
    const { data } = this.props;

    const file = data.files.edges
      .map(edge => {
        return edge.node;
      })
      .find(node => {
        return node.relativePath === url;
      });

    return (
      <StudyContainer>
        <Title>{title}</Title>
        <Row>
          <Verses>{versos}</Verses>
          <DateTime>
            {luxon.DateTime.fromISO(date)
              .setLocale("es")
              .toFormat("DD")}
          </DateTime>
        </Row>
        <Description>{description}</Description>
        {file && file.publicURL ? (
          <Download target="_blank" href={file.publicURL}>
            Descargar
          </Download>
        ) : null}
      </StudyContainer>
    );
  }
}

export const query = graphql`
  query EstudiosBiblicosPageQuery {
    files: allFile(filter: { sourceInstanceName: { eq: "estudios" } }) {
      edges {
        node {
          id
          publicURL
          relativePath
        }
      }
    }
  }
`;
